module.exports = __webpack_public_path__ + "img/166.f15e8ac3.png";